// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";
import { supportedSystemPositions } from "@/Common/helpers/Positions";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";
import DepartmentalWashoutLayer from "@/Washouts/views/Layers/Departmental/DepartmentalWashoutLayer";
import actionsList from "@Constants/actionsList";

const positions = supportedSystemPositions();
const POSITION = positions.PARTS.PARTS_COUNTER_ASSOCIATE;

export default function PartsCounterAssociateWashout() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	const actions = {
		OVERRIDE_COMPENSATION: actionsList.OVERRIDE_PARTS_COUNTER_ASSOCIATE_COMPENSATION,
	};

	return (
		<PageLayer title={`${POSITION} Washouts`} icon={Icon}>
			<DepartmentalWashoutLayer position={POSITION} actions={actions} positionType="Departmental" />
		</PageLayer>
	);
}
